import { render } from "./System-Tasks.vue?vue&type=template&id=17788480&scoped=true"
import script from "./System-Tasks.vue?vue&type=script&lang=js"
export * from "./System-Tasks.vue?vue&type=script&lang=js"

import "./System-Tasks.vue?vue&type=style&index=0&id=17788480&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17788480"]])

export default __exports__